import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'qaroni-label-project-name-preview',
  templateUrl: './label-project-name-preview.component.html',
  styleUrls: ['./label-project-name-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LabelProjectNamePreviewComponent {
  readonly showLineColor = input<boolean>(false);
  readonly color = input<string>('');
  readonly icon = input<string>('');
  readonly name = input<string>('');
}
